import { IconButton, Tooltip, useTheme } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { RowActions } from './style'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ClickToEditButton from './ClickToEditButton'
import { FC } from 'react'
import { DescCtx, OrgRow, Row } from './taskTypes'

type RowActionProps = {
  row: OrgRow | Row
  idx: number
  kind: 'prod' | 'org'
  removeRow: (idx: number) => void
  openEditor: (ctx: DescCtx, initial: string) => void
  cloneRowFrom: (srcIdx: number) => void
  onHoverStart?: () => void // NEW
  onHoverEnd?: () => void // NEW
}

const RowActionComponent: FC<RowActionProps> = ({
  row,
  idx,
  kind,
  openEditor,
  removeRow,
  cloneRowFrom,
  onHoverStart,
  onHoverEnd,
}) => {
  const theme = useTheme()
  return (
    <RowActions
      className="row-actions"
      onClick={e => e.stopPropagation()}
      onMouseEnter={onHoverStart} // keep active when entering actions
      onMouseLeave={onHoverEnd} // allow the grace period to hide
      onFocus={onHoverStart} // keyboard users
      onBlur={onHoverEnd}
    >
      <ClickToEditButton
        content={
          row?.addtlNotes && row?.addtlNotes !== ''
            ? row?.addtlNotes
            : `<div><p style="color: ${theme.palette.text.disabled};">No Description</p></div>`
        }
        onClick={() => openEditor({ kind: kind ?? 'prod', idx }, row?.addtlNotes)}
        isDraft
      />
      <Tooltip title="Duplicate this row">
        <IconButton size="medium" onClick={() => cloneRowFrom(idx)} tabIndex={0}>
          <ContentCopyIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Remove row">
        <IconButton size="medium" onClick={() => removeRow(idx)} tabIndex={0}>
          <DeleteOutlineIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </RowActions>
  )
}

export default RowActionComponent

// import { IconButton, Tooltip, useTheme } from '@mui/material'
// import ContentCopyIcon from '@mui/icons-material/ContentCopy'
// import { RowActions } from './style'
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
// import ClickToEditButton from './ClickToEditButton'
// import { FC } from 'react'
// import { DescCtx, OrgRow, Row } from './taskTypes'

// interface RowActionProps {
//   row: OrgRow | Row
//   idx: number
//   removeRow: (idx: number) => void
//   openEditor: (ctx: DescCtx, initial: string) => void
//   cloneRowFrom: (srcIdx: number) => void
// }

// const RowActionComponent: FC<RowActionProps> = ({ row, idx, openEditor, removeRow, cloneRowFrom }) => {
//   const theme = useTheme()
//   return (
//     <RowActions className="row-actions" onClick={e => e.stopPropagation()}>
//       <ClickToEditButton
//         content={
//           row?.addtlNotes && row?.addtlNotes !== ''
//             ? row?.addtlNotes
//             : `<div><p style="color: ${theme.palette.text.disabled};">No Description</p></div>`
//         }
//         onClick={() => openEditor({ kind: 'prod', idx }, row?.addtlNotes)}
//         isDraft
//       />
//       <Tooltip title="Duplicate this row">
//         <IconButton aria-label="Duplicate row" size="medium" onClick={() => cloneRowFrom(idx)} tabIndex={0}>
//           <ContentCopyIcon fontSize="medium" />
//         </IconButton>
//       </Tooltip>
//       <Tooltip title="Remove row">
//         <IconButton aria-label="Remove row" size="medium" onClick={() => removeRow(idx)} tabIndex={0}>
//           <DeleteOutlineIcon fontSize="medium" />
//         </IconButton>
//       </Tooltip>
//     </RowActions>
//   )
// }
// export default RowActionComponent
